import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsOverview = ({ data }) => {
  const metrics = [
    {
      title: 'Total Leads',
      value: data?.totalLeads?.toLocaleString() || '0',
      icon: 'Users',
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      description: 'Total leads in pipeline'
    },
    {
      title: 'Converted Leads',
      value: data?.convertedLeads?.toLocaleString() || '0',
      icon: 'Trophy',
      color: 'text-green-600',
      bg: 'bg-green-50',
      description: 'Successfully converted'
    },
    {
      title: 'Conversion Rate',
      value: `${data?.conversionRate || 0}%`,
      icon: 'TrendingUp',
      color: 'text-purple-600',
      bg: 'bg-purple-50',
      description: 'Lead to customer rate'
    },
    {
      title: 'Active Campaigns',
      value: data?.activeCampaigns?.toString() || '0',
      icon: 'Send',
      color: 'text-orange-600',
      bg: 'bg-orange-50',
      description: 'Currently running'
    },
    {
      title: 'Total Campaigns',
      value: data?.totalCampaigns?.toString() || '0',
      icon: 'Mail',
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      description: 'All time campaigns'
    },
    {
      title: 'Communications',
      value: data?.totalCommunications?.toString() || '0',
      icon: 'MessageSquare',
      color: 'text-pink-600',
      bg: 'bg-pink-50',
      description: 'Total interactions'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {metrics?.map((metric, index) => (
          <div key={index} className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
            <div className="flex items-center space-x-4">
              <div className={`p-3 rounded-lg ${metric?.bg}`}>
                <Icon name={metric?.icon} size={24} className={metric?.color} />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">{metric?.title}</p>
                <p className="text-2xl font-bold text-foreground">{metric?.value}</p>
                <p className="text-xs text-muted-foreground mt-1">{metric?.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Source Breakdown */}
      {data?.sourceBreakdown?.length > 0 && (
        <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
          <h3 className="text-lg font-semibold text-foreground mb-4">Lead Sources</h3>
          <div className="space-y-3">
            {data?.sourceBreakdown?.map((item, index) => {
              const total = data?.totalLeads || 1;
              const pct = Math.round((item?.count / total) * 100);
              return (
                <div key={index} className="flex items-center space-x-3">
                  <span className="text-sm text-muted-foreground w-24 capitalize">{item?.source?.replace('_', ' ')}</span>
                  <div className="flex-1 bg-muted rounded-full h-2">
                    <div className="bg-primary h-full rounded-full" style={{ width: `${pct}%` }} />
                  </div>
                  <span className="text-sm font-medium text-foreground w-12 text-right">{item?.count}</span>
                  <span className="text-xs text-muted-foreground w-10 text-right">{pct}%</span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {(!data || data?.totalLeads === 0) && (
        <div className="bg-card border border-border rounded-lg p-12 text-center">
          <Icon name="BarChart3" size={48} className="text-muted-foreground mx-auto mb-4 opacity-40" />
          <h3 className="text-lg font-semibold text-foreground mb-2">No Analytics Data Yet</h3>
          <p className="text-muted-foreground">Start adding leads and running campaigns to see your analytics here.</p>
        </div>
      )}
    </div>
  );
};

export default MetricsOverview;